// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.titleSystem {\n    font-size: 1vw;\n    font-weight: bold;\n    color: #ffffff;\n    letter-spacing: 5px;\n    margin: 1vw;\n}\n", ""]);
// Exports
module.exports = exports;
